export enum FigmaSyncType {
    CREATE = "createFigmaLibSync",
    UPDATE = "updateFigmaLibSync"
}

export const FIGMA_ACCESS_DENIED_ERROR_TITLE = "Can’t connect to Figma";

export const FIGMA_REDIRECT_ERROR_TITLES = [
    "You can't upload designs to this project",
    "Can't find the Figma file",
    "Please upgrade your plan first"
];

export const FIGMA_PLACEHOLDER_STYLEGUIDE_ID = "creatingStyleguide";
